import Swiper from 'swiper/dist/js/swiper.js';

function init() {
  const mediumScreen  = (window.innerWidth <= 1023) ? true : false;

  if (mediumScreen && !window.propertyDataSwiper) {
    const propertydataSwiper = document.querySelector('.propertydata__swiper');
    const propertydataSwiperSelector = '.swiper-container.propertydata__swiper';

    if (propertydataSwiper) {
      window.propertyDataSwiper = new Swiper (propertydataSwiperSelector, {
        direction: 'horizontal',
        speed: 1000,
        loop: false,
        centeredSlides: true,
        slidesPerView: 'auto',
        autoplay: {
          delay: 3000,
          disableOnInteraction: true,
        },
      });
    }
  } else if (!mediumScreen && window.propertyDataSwiper) {
    window.propertyDataSwiper.forEach((swiper) => {
      swiper.destroy();
    });
    delete window.propertyDataSwiper;
  }
}

export default init;



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Propertydata.js